import React from 'react';
import PropTypes from 'proptypes';


export const IconComponent = ({ src, title, className }) => (
  <svg viewBox={src.viewBox} className={`icon ${className || ''}`}>
    <use xlinkHref={`#${src.id}`} />
  </svg>
);

IconComponent.propTypes = {
  src: PropTypes.shape({
    viewBox: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
};

IconComponent.defaultProps = {
  title: null,
  className: null,
};



// WEBPACK FOOTER //
// ./src/components/icon/icon.component.js